import axios from "axios";
import authHeader from "./auth-header";
import http from "./http-common";
import { API_URLU } from "../config/constant";

const getUserById = (id) => {
  return axios.get(API_URLU + "user/" + id, { headers: authHeader() });
};

const getUserBycmp = (id) => {
  return axios.get(API_URLU + "company-users?cmpId=" + id, {
    headers: authHeader(),
  });
};

const getUsers = () => {
  return axios.get(API_URLU + "user", { headers: authHeader() });
};

const getUserByName = (username) => {
  return axios.get(API_URLU + "userName/" + username, {
    headers: authHeader(),
  });
};

const postUser = (data) => {
  return axios.post(API_URLU + "user", data, { headers: authHeader() });
};

const getCompById = (id) => {
  return axios.get(API_URLU + "company/" + id, { headers: authHeader() });
};

const getCompanies = () => {
  return axios.get(API_URLU + "company", { headers: authHeader() });
};

const postComp = (data) => {
  return axios.post(API_URLU + "company", data, { headers: authHeader() });
};

const getSystemById = (id) => {
  return axios.get(API_URLU + "system/" + id, { headers: authHeader() });
};

const getSystems = () => {
  return axios.get(API_URLU + "system", { headers: authHeader() });
};

const postSystem = (data) => {
  return axios.post(API_URLU + "system", data, { headers: authHeader() });
};

const postUserComp = (details) => {
  return axios.post(API_URLU + "ucompany", details, { headers: authHeader() });
};

const deleteUserComp = (id) => {
  return axios.delete(API_URLU + "ucompany/" + id, { headers: authHeader() });
};

const updateUserComp = (data) => {
  return axios.get(
    API_URLU +
      "update-comp-user?ucmId=" +
      data.ucmId +
      "&adminYN=" +
      data.adminYN,
    { headers: authHeader() }
  );
};

const getUserComp = (id) => {
  return axios.get(API_URLU + "user-companies?userId=" + id, {
    headers: authHeader(),
  });
};

const getMasterUserComp = (id) => {
  return axios.get(API_URLU + "master-user-companies?userId=" + id, {
    headers: authHeader(),
  });
};

const postUserSystems = (data) => {
  return axios.post(API_URLU + "user-systems", data, { headers: authHeader() });
};

const getCompSystems = (id) => {
  return axios.get(API_URLU + "company-systems?cmpId=" + id, {
    headers: authHeader(),
  });
};

const getCompUSystems = (id) => {
  return axios.get(API_URLU + "company-unsubscribed-systems?cmpId=" + id, {
    headers: authHeader(),
  });
};

const getUserCompSystems = () => {
  return axios.get(API_URLU + "user-company-systems", {
    headers: authHeader(),
  });
};

const getUserCompUSystems = () => {
  return axios.get(API_URLU + "user-company-usystems", {
    headers: authHeader(),
  });
};

const getUserUnsubscribedSystems = (data) => {
  return axios.get(
    API_URLU +
      "user-unsubscribed-systems?cmpId=" +
      data.cmpId +
      "&username=" +
      data.username,
    { headers: authHeader() }
  );
};

const getCustomerById = (id) => {
  return axios.get(API_URLU + "customer/" + id, { headers: authHeader() });
};

const getCustomers = () => {
  return axios.get(API_URLU + "customerIntermediary/Y", {
    headers: authHeader(),
  });
};

const getAciveCustomers = () => {
  return axios.get(API_URLU + "customerActive/Y", { headers: authHeader() });
};

const postCustomer = (data) => {
  return axios.post(API_URLU + "customer", data, { headers: authHeader() });
};

const putCustomer = (id, data) => {
  return axios.put(API_URLU + "customer/" + id, data, {
    headers: authHeader(),
  });
};

const getEmployeeById = (id) => {
  return axios.get(API_URLU + "chr_employee/" + id, { headers: authHeader() });
};

const getEmployeeByUsername = (name) => {
  return axios.get(API_URLU + "chr_by_username/" + name, {
    headers: authHeader(),
  });
};

const getEmployees = () => {
  return axios.get(API_URLU + "chr_employee", { headers: authHeader() });
};

const getPagedEmployees = (offset, pageSize) => {
  return axios.get(API_URLU + "employee/" + offset + "/" + pageSize, {
    headers: authHeader(),
  });
};

const postEmployee = (data) => {
  return axios.post(API_URLU + "employee", data, { headers: authHeader() });
};

const putEmployee = (id, data) => {
  return axios.put(API_URLU + "employee/" + id, data, {
    headers: authHeader(),
  });
};

const getClassification = () => {
  return axios.get(API_URLU + "classification", { headers: authHeader() });
};

const getGeneral = () => {
  return axios.get(API_URLU + "general", { headers: authHeader() });
};

const postTempBranch = (data) => {
  return axios.post(API_URLU + "tbranch", data, { headers: authHeader() });
};

const getTempBranch = () => {
  return axios.get(API_URLU + "tbranch", { headers: authHeader() });
};

const saveInvoice = (invoice) => {
  return axios.post(API_URLU + "SaveInvoice", invoice, {
    headers: authHeader(),
  });
};

const getInvoiceInfo = () => {
  return axios.get(API_URLU + "getInfo", { headers: authHeader() });
};

const postQuote = (data) => {
  return axios.post(API_URLU + "icr_quotes", data, { headers: authHeader() });
};

const getReturnDate = (data) => {
  return axios.get(
    API_URLU +
      "return_date?startDate=" +
      data.startDate +
      "&appliedDays=" +
      data.appliedDays +
      "&leaveCode=" +
      data.leaveCode +
      "&cmpId=" +
      data.cmpId,
    { headers: authHeader() }
  );
};

const getQuoteNo = (data) => {
  return axios.get(
    API_URLU + "quote_no?cmpId=" + data.cmpId + "&transType=" + data.transType,
    { headers: authHeader() }
  );
};

const getQuotes = (data) => {
  return axios.get(
    API_URLU + "icr_quotes/" + data.cmpId + "/" + data.quoteStatus,
    { headers: authHeader() }
  );
};

const getIcrProducts = (cmpId) => {
  return axios.get(API_URLU + "icr_product_native?cmpId=" + cmpId, {
    headers: authHeader(),
  });
};

const getIcrProductCat = (cmpId) => {
  return axios.get(API_URLU + "icr_product_cat?cmpId=" + cmpId, {
    headers: authHeader(),
  });
};

const createRisks = (data) => {
  return axios.post(API_URLU + "icr_quote_risks", data, {
    headers: authHeader(),
  });
};

const createSections = (data) => {
  return axios.post(API_URLU + "icr_quote_risksection", data, {
    headers: authHeader(),
  });
};

const getProductSections = (data) => {
  return axios.get(
    API_URLU +
      "icr_product_section_native?pCode=" +
      data.code +
      "&cmpId=" +
      data.id,
    { headers: authHeader() }
  );
};

const createProduct = (data) => {
  return axios.post(API_URLU + "icr_products", data, { headers: authHeader() });
};

const createProductSection = (data) => {
  return axios.post(API_URLU + "icr_product_sections", data, {
    headers: authHeader(),
  });
};

const updatePass = (data) => {
  return axios.patch(API_URLU + "changepwd", data, { headers: authHeader() });
};

const updateUser = (data) => {
  return axios.get(
    API_URLU +
      "update-user-profile?id=" +
      data.id +
      "&longName=" +
      data.longName +
      "&email=" +
      data.email +
      "&phone=" +
      data.phone,
    { headers: authHeader() }
  );
};

const updateUserImg = (data) => {
  return axios.get(
    API_URLU + "update-user-image?id=" + data.id + "&photoUrl=" + data.photoUrl,
    { headers: authHeader() }
  );
};

const updateCompSystems = (data) => {
  return axios.get(
    API_URLU +
      "update-comp-system?cmpId=" +
      data.cmpId +
      "&sstId=" +
      data.sstId +
      "&username=" +
      data.createdBy +
      "&createdDate=" +
      data.createdDate,
    { headers: authHeader() }
  );
};

// const uploadFile = (file, onUploadProgress) => {
//   let formData = new FormData();

//   formData.append("file", file);
//   return axios.post(API_URLU + "singleUpload/", formData, { headers: authHeader(), onUploadProgress })}

// const getFiles = () => {
//   return axios.get(API_URLU + "files/", { headers: authHeader() })}

const uploadFile = (file) => {
  let formData = new FormData();

  formData.append("file", file);

  return http.post("/singleUpload", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const uploadExcel = (file) => {
  let formData = new FormData();

  formData.append("file", file);

  return http.post("/upload_chr_employees", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const getUserRights = (data) => {
  return axios.get(API_URLU + 'userRights?sstId=' + data.sstId + '&username=' + data.username, {
    headers: authHeader()
  });
};

const getUserAllSubSystems = (data) => {
  return axios.get(API_URLU + 'user-all-sub-systems?cmpId=' + data.cmpId + '&username=' + data.username, {
    headers: authHeader()
  });
};

const getUpdate = (data) => {
  return axios.get(API_URLU + 'update-user-rights?approve=' + data.approve + '&initiate=' +data.initiate +'&sstId=' + data.sstId + '&username=' + data.username, {
    headers: authHeader()
  });
};



// const getFiles = (fileName) => {
//   return http.get(API_URLU + "download/" + fileName, { headers: authHeader() })}

// const getFiles = () => {
//   return http.get('/files');
// };

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getUserById,
  getUsers,
  postUser,
  updateUser,
  updateUserImg,
  getCompById,
  getCompanies,
  postComp,
  getSystemById,
  getSystems,
  postSystem,
  postUserComp,
  postUserSystems,
  getUserComp,
  getCompSystems,
  getUserCompSystems,
  getUserCompUSystems,
  getCustomerById,
  getCustomers,
  getAciveCustomers,
  postCustomer,
  putCustomer,
  getEmployeeById,
  getEmployeeByUsername,
  getEmployees,
  getPagedEmployees,
  postEmployee,
  putEmployee,
  getClassification,
  getGeneral,
  // getFiles,
  saveInvoice,
  getInvoiceInfo,
  getReturnDate,
  uploadFile,
  uploadExcel,
  postTempBranch,
  getTempBranch,
  getQuoteNo,
  postQuote,
  getQuotes,
  getIcrProducts,
  createRisks,
  createSections,
  getProductSections,
  getIcrProductCat,
  createProduct,
  createProductSection,
  updatePass,
  getUserBycmp,
  getUserByName,
  getUserUnsubscribedSystems,
  getCompUSystems,
  updateCompSystems,
  updateUserComp,
  deleteUserComp,
  getMasterUserComp,
  getUserRights,
  getUserAllSubSystems,
  getUpdate
};
